export enum ContentType {
    HTML = 'HTML',
    MARKDOWN = 'MARKDOWN',
    PLAIN_TEXT = 'PLAIN_TEXT',
    UNSPECIFIED = 'UNSPECIFIED',
}
